var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "-49.8910072%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E92B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFFA8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-Files",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.65859375
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_index-Agency",
    transform: "translate(-133.000000, -562.000000)",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner",
    transform: "translate(127.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(0.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    transform: "translate(12.500000, 329.500000) rotate(-228.000000) translate(-12.500000, -329.500000) ",
    points: "2 323 12.5983607 336 23 323"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape3.592e5a46c3736dd1ba0a4ca80da57a17.svg";
export { ForwardRef as ReactComponent };